// extracted by mini-css-extract-plugin
module.exports = {"container":"LocalizationFlagCell_container__TSqe9"};